import { createContext, useContext, useState, useCallback } from 'react'

import { Snackbar } from '@mui/material'

export const SnackbarContext = createContext()

export const useSnackbar = () => useContext(SnackbarContext)

export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')

  const showMessage = useCallback((msg) => {
    setMessage(msg)
    setOpen(true)
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <SnackbarContext.Provider value={{ showMessage }}>
      {children}
      <Snackbar
        autoHideDuration={7000}
        message={message}
        onClose={handleClose}
        open={open}
      />
    </SnackbarContext.Provider>
  )
}
